import { ActionTree } from "vuex";
import { IDemandEditState } from "./states.store";
import { IDemandModel, IDemandSmartSuggestion, ISmartSuggest, DemandProposalParameterModel, IDemandProposalListing } from "../../../models/demand";
import { GenericBaseParameter } from "../../../models/base-parameter";
import { DemandServices } from "../../../services";
import { IListing } from "../../../models/listing-base-model";
import demandTypesStore from "./demand-types.store";
import { deepClone } from "fast-json-patch/lib/core";
import moduleConstant from "../../../common/module-constant";

const actions = <ActionTree<IDemandEditState, any>>{
    [demandTypesStore.Set.MODAL_VISIBLE]: async ({ getters, commit }, { demandId, propertyId, personId, signal }) => {
        let requestHolder: Promise<IDemandModel>;
        if (!demandId) {
            requestHolder = getters.service.initDemand();
            if (propertyId || personId) {
                requestHolder = getters.service.initDemandWithProperty(propertyId, personId);
            }
        } else requestHolder = getters.service.getDemandById(demandId, signal ? { signal } : undefined);
        return requestHolder
            .then((demand: IDemandModel) => {
                if (signal?.aborted) return;
                return getters.service.populateDetail2Token(demand)
                    .then(res => {
                        if (signal?.aborted) return;
                        commit(demandTypesStore.Set.DEMAND, res);
                        commit(demandTypesStore.Set.DEMANDORIGIN, deepClone(res));
                        return Promise.resolve(true);
                    })
                    .catch(ex => {
                        if (signal?.aborted) return;
                        // this.$notify.error(ex);
                        console.log(ex);
                    });
            })
            .catch(error => {
                if (signal?.aborted) return;
                return Promise.reject(error);
            });
    },

    [demandTypesStore.Get.LIST_OF_CRITERIAS]: (
        { commit, getters },
        param: IDemandSmartSuggestion
    ) => {
        return getters.service[demandTypesStore.Get.LIST_OF_CRITERIAS](param)
            .then((listOfSmartCriterias: ISmartSuggest[]) => {
                return Promise.resolve(listOfSmartCriterias);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    },
    [demandTypesStore.Get.LIST_OF_PROPOSALS]: (
        { getters, commit },
        payload: {
            id: number;
            param: GenericBaseParameter<DemandProposalParameterModel>;
        }
    ) => {
        return (getters.service as DemandServices)
            .getListOfProposals(payload.id, payload.param)
            .then((listingResult: IListing<IDemandProposalListing>) => {
                return Promise.resolve(listingResult);
            })
            .catch(ex => {
                return Promise.reject(ex);
            });
    },
    [demandTypesStore.Set.NEW_DEMAND]: ({ commit, getters }, option) => {
        commit(demandTypesStore.Set.SET_IS_SAVING, true);
        return getters.service[demandTypesStore.Set.NEW_DEMAND](getters.demand)
            .then((result: any) => {
                commit('common/setNotificationMessage', { type: 'success', action: 'ADD', module: 'DEMAND', id: option.tempId, newId: result.Id, ref: getters.demand.PersonInfo.Reference }, { root: true });
                return Promise.resolve(result);
            })
            .catch(ex => {
                commit(demandTypesStore.Set.SET_IS_SAVING, false);
                console.log(ex);

                if (ex.errorCode !== -1000) {
                    commit('common/setNotificationMessage', { type: 'error', action: 'ADD', module: 'DEMAND', message: ex, id: option.tempId, ref: getters.demand.PersonInfo.Reference }, { root: true })
                }
                return Promise.reject(ex);
            });
    },

    [demandTypesStore.Set.UPDATE_DEMAND]: ({ commit, getters }, option) => {
        commit(demandTypesStore.Set.SET_IS_SAVING, true);
        return getters.service[demandTypesStore.Set.UPDATE_DEMAND](option.origin, getters.demand)
            .then(result => {
                commit(demandTypesStore.Set.DEMANDORIGIN, deepClone(getters.demand));
                commit('common/setNotificationMessage', { type: 'success', action: 'M_EDIT_NEW', module: 'DEMAND', id: getters.demand.Id, ref: getters.demand.PersonInfo.Reference }, { root: true });
                return Promise.resolve(result);
            })
            .catch(ex => {
                commit(demandTypesStore.Set.SET_IS_SAVING, false);
                if (ex.code === 24005) {
                    commit('common/setVisibleConflictDataInfo', { module: moduleConstant.Demand, id: getters.demand.Id, data: { entity: getters.demand, origin: getters.origin } }, { root: true });
                    return Promise.reject(ex);;
                }
                if (ex.errorCode !== -1000) {
                    commit('common/setNotificationMessage', { type: 'error', action: 'M_EDIT_NEW', module: 'DEMAND', message: ex.data.msg, id: getters.demand.Id, ref: getters.demand.PersonInfo.Reference }, { root: true })
                }
                return Promise.reject(ex);
            });
    },

    [demandTypesStore.Set.DELETE_DEMAND]: ({ commit, getters }, ids: number[]) => {
        return getters.service[demandTypesStore.Set.DELETE_DEMAND](ids)
            .then(result => {
                return Promise.resolve(true);
            })
            .catch(ex => {
                return Promise.reject(ex);
            });
    },
    [demandTypesStore.Get.CONFIG]: ({ getters, commit }) => {
        return (getters.service as DemandServices)
            .getDemandConfigs()
            .then((result) => {
                commit(demandTypesStore.Set.CONFIG, result);
                return Promise.resolve(result);
            })
            .catch(ex => {
                return Promise.reject(ex);
            });
    },
};

export default actions;
